import { render } from "./Loantable.vue?vue&type=template&id=58f4b4be"
import script from "./Loantable.vue?vue&type=script&lang=js"
export * from "./Loantable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__